import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Header from '../../components/Header';

const Blocked = (props) => {
  const { checkinData, params, searchParams } = props;
  const strHeadLine = useMemo(() => (get(checkinData, 'data.data.hardPullDisclosure') ? 'Your loan status has changed. After further review, unfortunately we are no longer able to approve your application.' : 'Unfortunately, your application was not approved at this time.'), [checkinData]);
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    const { navigate } = props;

    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <div className="content">
        <h1>{strHeadLine}</h1>
      </div>
    </div>
  );
};

Blocked.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Blocked);
